import axios from 'axios';

import { SetupAccountRequest } from '@/module/Setup/model/SetupTypes';

import { getData } from '@feature/utils';

export function setupAccount(request: SetupAccountRequest) {
  return axios.post<unknown>('/current-author/profile/setup-account', request).then(getData);
}
